import React from 'react';
import ReactQuill from 'react-quill';
import { modules, formats } from './quill_config';


export const VolitionExtraEditor = ({ updateCmsPostForm, cmsPostForm }) => {
  const updateGettingStarted = (key, value) => {
    const newCmsPostForm = { ...cmsPostForm.content.body };
    newCmsPostForm[key] = value;

    updateCmsPostForm('content', { body: newCmsPostForm });
  };

  return (
    <div>
      <br />
      <br />
      <div className="portfolio-management-form-flex space-between">
        <div className="portfolio-managment-input-block full">
          <label htmlFor="Message" className="form-field-label">
            Volition Extra Writeup
            <span className="gray-text" />
          </label>
          <ReactQuill
            onChange={(html) => updateGettingStarted('extra_writeup', html)}
            value={cmsPostForm.content.body.extra_writeup ?? ''}
            modules={modules}
            formats={formats}
            theme="snow" />
        </div>
      </div>
    </div>
  );
};
